import React, { useState, useEffect } from 'react';
import axios from 'axios';

const HeroCarouselManager = () => {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({
    link: '',
    order_index: 0,
    is_active: true
  });
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/hero-carousel', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setItems(response.data);
    } catch (error) {
      console.error('Error fetching items:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();
      
      if (imageFile) {
        formDataToSend.append('image', imageFile);
      } else if (editingItem) {
        formDataToSend.append('image_url', editingItem.image_url);
      }
      
      formDataToSend.append('link', formData.link);
      formDataToSend.append('order_index', formData.order_index);
      formDataToSend.append('is_active', formData.is_active);

      if (editingItem) {
        await axios.put(`/api/hero-carousel/${editingItem.id}`, formDataToSend, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {
        await axios.post('/api/hero-carousel', formDataToSend, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      fetchItems();
      resetForm();
    } catch (error) {
      console.error('Error saving item:', error);
      alert('Kaydetme hatası: ' + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu öğeyi silmek istediğinizden emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/hero-carousel/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchItems();
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Silme hatası');
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      link: item.link || '',
      order_index: item.order_index,
      is_active: item.is_active
    });
    setShowForm(true);
  };

  const resetForm = () => {
    setFormData({ link: '', order_index: 0, is_active: true });
    setImageFile(null);
    setEditingItem(null);
    setShowForm(false);
  };

  return (
    <div className="bg-gradient-card rounded-xl p-6 border border-accent/30">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-accent">Ana Reklam Kartı Yönetimi</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-accent hover:bg-accent-dark text-white px-4 py-2 rounded-lg transition-colors"
        >
          {showForm ? 'İptal' : '+ Yeni Ekle'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-navy-700 p-6 rounded-lg mb-6 space-y-4">
          <div>
            <label className="block text-white mb-2">Görsel {!editingItem && '*'}</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImageFile(e.target.files[0])}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
              required={!editingItem}
            />
          </div>

          <div>
            <label className="block text-white mb-2">Link (opsiyonel)</label>
            <input
              type="url"
              value={formData.link}
              onChange={(e) => setFormData({ ...formData, link: e.target.value })}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
              placeholder="https://example.com"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Sıra</label>
            <input
              type="number"
              value={formData.order_index}
              onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) })}
              className="w-full px-3 py-2 bg-navy-600 border border-accent/30 rounded text-white"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
              className="w-4 h-4"
            />
            <label className="text-white">Aktif</label>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-accent hover:bg-accent-dark text-white font-bold py-2 px-4 rounded-lg transition-colors disabled:opacity-50"
          >
            {loading ? 'Kaydediliyor...' : (editingItem ? 'Güncelle' : 'Ekle')}
          </button>
        </form>
      )}

      <div className="space-y-4">
        {items.map((item) => (
          <div key={item.id} className="bg-navy-700 p-4 rounded-lg flex items-center gap-4">
            <img
              src={item.image_url && item.image_url.startsWith('http') ? item.image_url : item.image_url || ''}
              alt="Carousel"
              className="w-32 h-20 object-cover rounded"
            />
            <div className="flex-1">
              <p className="text-white">Link: {item.link || 'Yok'}</p>
              <p className="text-white/60 text-sm">Sıra: {item.order_index}</p>
              <p className="text-white/60 text-sm">Durum: {item.is_active ? 'Aktif' : 'Pasif'}</p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleEdit(item)}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
              >
                Düzenle
              </button>
              <button
                onClick={() => handleDelete(item.id)}
                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
              >
                Sil
              </button>
            </div>
          </div>
        ))}

        {items.length === 0 && (
          <p className="text-center text-white/60 py-8">Henüz öğe eklenmedi</p>
        )}
      </div>
    </div>
  );
};

export default HeroCarouselManager;
